export {
  default as SvgIcon,
  type SvgIconProps,
  svgIconClasses,
} from '@mui/material/SvgIcon';
